import React, { useEffect, useState,useRef,useContext   } from "react"
import { apiEndpoint } from "helpers/url_helper";
import jsPDF from "jspdf";
import "jspdf-autotable";
import MetaTags from 'react-meta-tags';
import Select from "react-select";
import moment from "moment";
import JSZip, { file } from "jszip";
//import Picker from 'react-month-picker'
import AuthContext from "store/auth/authContext";
import FileSaver from "file-saver";
import {
    Col,
    Row,
    Card,
    CardBody,
    Button,
    ButtonGroup,
    UncontrolledTooltip,Spinner
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next"
// import 'assets/scss/custom/pages/common.scss';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
//import ReactToPrint from "react-to-print";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { connect } from "react-redux";
import paginationFactory from 'react-bootstrap-table2-paginator';
//import overlayFactory  from 'react-bootstrap-table2-overlay';

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";

import ViewImageModalComponent from './ViewImageModal';
import EditViolationModalComponent from './EditViolationModal'
import { ReportType, SearchData, SpeedType } from './ViolationLogsComponents';

import {ViolationsContext} from "components/Common/PageDataContext";

import getCurrentDate from "components/Common/Utility"
import { forEach, size } from "lodash";

import jwt from "jsonwebtoken";

//Style
const btnstylesObj = {
    "margin-top": '2rem',
  };



  

  
 // This is  custom csv export component
const ExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
        <Button  size="sm" id="csv-tooltip"
        className="buttons-copy buttons-html5"
        color="dark" onClick={ handleClick }> 
        <span>Csv</span></Button>
    );
  };

const ViolationTables = (props) => {
  const { SearchBar } = Search;

    //Print function
    const componentRef = useRef();
    const [Campusitems, setCampusItems] = useState([]);
    const [SelectedCampusitem, setSelectedCampusItem] = useState([]);
    const [selectedCampusVal, setCampusSelected] = useState();

    const [FromDtTm, setFrmDttm] = useState(moment().format("YYYY-MM-DD 00:00"));
    const [ToDtTm, setToDttm] = useState(moment().format("YYYY-MM-DD HH:mm"));

    const [Monthlyrt, setMonthlyrt] = useState(moment().format("YYYY-MM"));

    const [FromSpeed, setFrmSpeed] = useState(20);
    const [ToSpeed, setToSpeed] = useState(100);
    const [BoolANPR, setANPR] = useState(true);

    const [selectedReportTypeVal, setReportType] = useState(1);
    const [selectedSpeedTypeVal, setSpeedType] = useState(1);

    const[ selectonLoadLocVal, setselectonLoadLocVal] = useState();

    const [editviolations, seteditviolations] = useState();

    var today = new Date();
    var datefilename = getCurrentDate()+ '_Logs.csv';

    const[selectedSizePage, setSelectedSizePage] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const [isDownloadingImage, setIsDownloadingImage] = useState(false);


 const SearchViolations = () => {
     // useEffect(() => {
      setViolations([]);
      debugger;
      setIsLoading(true);

if(ToSpeed >=1 && FromSpeed >=1)
{
  // UserValidated
  fetch(apiEndpoint+"/GetViolationLogs",
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "intCampusID": selectedCampusVal,// 1,
                "intLocationID": selectedLocVal,//1,
                "intReportType": selectedReportTypeVal,//1,
                "FromDtTm": FromDtTm,
                "ToDtTm": ToDtTm,
                "MonthlyRt": Monthlyrt,
                "intSpeedType": selectedSpeedTypeVal,//1,
                "FromSpeed": FromSpeed,
                "ToSpeed": ToSpeed,
                "boolOnlyANPR": BoolANPR,
                "strToken": sessionStorage.getItem("Clear_AuthUser")
             })
        })
        .then(res => res.json())
        .then(
            (result) => {
                if(result!=undefined)
                {
                  debugger;
                  //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                //console.log(result);
                if(JSON.parse(result.Violations).length>0){
                  setViolations(JSON.parse(result.Violations));
                  setSlicedViolation(JSON.parse(result.Violations).slice(0,10));

                }
                  else
                  setViolations([]);
                }
                setIsLoading(false);

            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                //setError(error);
            }
        )

}
      
    
   // }, [violations])


}

const DownloadImage =  (slice) => {
  debugger;
var slicedData = slice.current.table.props.data.map(obj =>{
  var tempData = {};
  const mapping = ['RecordID', 'ImagePath'];
  tempData["RecordID"] = obj.RecordID;
  tempData["ImagePath"] = obj.ImagePath;
  return tempData;
});
  console.log("DownloadImage------Slice---->", slicedViolation);
if(slicedData.length <= 100)
{
  setIsDownloadingImage(true);

  const currDate = new Date().toLocaleDateString();
  //const currTime = new Date().toLocaleTimeString();

  console.log(currDate);
  currDate.replace("/","_");
  currDate.replace("/","_");
  const FileName = "AdorIndusImages"+currDate+".zip";
  console.log(FileName);

  // can't change
   fetch(apiEndpoint+"/GetDownloadedImages",
      {
        mode: "cors",
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          //'Access-Control-Allow-Origin': '*',
        
        },
        body: JSON.stringify(slicedData)
      })
      .then(response => response.blob())
    .then(blob => {
      debugger;
      saveAs(blob, FileName);
    // const url = window.URL.createObjectURL(blob);
    // const a = document.createElement('a');
    // a.href = url;
    // a.download = FileName;
    // a.click();
    setIsDownloadingImage(false);
  });


}
else{
  setAlert (
    <ReactBSAlert
      error
    //   style={bsAlertStyle}
    //   title="Good job!"
      onConfirm={() => setAlert(null)}
      onCancel={() => setAlert(null)}
      confirmBtnBsStyle="info"
    >
     Download Failed
    </ReactBSAlert>
  )
}
  



 

  
}

const exportPDF = () => {
  const unit = "pt";
  const size = "A3"; // Use A1, A2, A3 or A4
  const orientation = "portrait"; // portrait or landscape

  const marginLeft = 40;
  const doc = new jsPDF(orientation, unit, size);

  doc.setFontSize(15);
 // doc.autoTable({headStyles :{fillColor : [124, 95, 240]}, alternateRowStyles: {fillColor : [231, 215, 252]} }); 
  const title = "Violation Logs";
  const headers = [["Campus Name", "Location Name","Incident Time","Type Of Violation","Registration Number","Speed of Offence","Speed Limit"]];

  const data = violations.map(log=> [log.CampusName,log.LocationName,log.IncidentTime,log.TypeOfViolation,log.RegistrationNumber,log.VehicleSpeed,log.SpeedLimit]);
  console.log("PDF Records------->",data);
  let content = {
    startY: 50,
    head: headers,
    body: data
  };

  doc.text(title, marginLeft, 40);
  doc.autoTable(content);
  doc.save(getCurrentDate()+ '_Logs.pdf')
}

const DisablePrintCol = () =>
{
  debugger;
  const DisblePrintColumn = document.getElementById('DisbalePrint');
  if(DisblePrintCol)
  {
    DisablePrintColumn.style.display = "none";
  }

}
    const breadcrumbItems = [
     
        //  { title: "Violation Logs", link: "/ViolationLogs" },
    ]
    const [violations, setViolations] = useState([]);
    const Contextvalue = { violations, setViolations };
    const [alertmsg, setAlert] = useState([]);

    const[slicedViolation, setSlicedViolation] = useState([]);

  const DateTimeFormatter = (data,row) =>{
     return<>
      {data.replace('T',' ')}
    </>
  }
 const RegistrationNumberFormatter = (data, row)=>{
  
  if(data.includes("Unknown"))
 {
      
    return<>
    {data.replace('Unknown', '-')}
  </> 
   }
  else{
    return<>
    {data}
  </>
  }


 }

    const columns = [
      {
        dataField: "RecordID",
        text: "RecordID",
        hidden: true,
        csvExport :false
    },
        {
            dataField: "CampusName",
            text: "Campus Name",
            sort: true,
            headerStyle: (colum, colIndex) => {
              
              return { width: '150px', textAlign: 'center', backgroundColor: '#5b626b', color:'white',  position:'sticky' };
            }

          
        },
    
        {
            dataField: "LocationName",
            text: "Location Name",
            sort: true,
            headerStyle: (colum, colIndex) => {
              return { width: '150px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
            }
        },
    
        {
            dataField: "IncidentTime",
            text: "Incident Datetime",
            sort: true,
            headerStyle: (colum, colIndex) => {
              return { width: '170px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
            },
            
            formatter:(cell) => cell.replace('T',' ')
        },
        {
          dataField: "TypeOfViolation",
          text: "Event Type",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: '150px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
          },
      
          
      },
        {
            dataField: "RegistrationNumber",
            text: "Reg Number",
            sort: true,
            headerStyle: (colum, colIndex) => {
              return { width: '165px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
            },
            formatter:(cell) => cell.replace('Unknown','-')

        },
        // {
        //     dataField: "LaneNumber",
        //     text: "Lane Number",
        //     sort: true
        // },
        {
            dataField: "VehicleSpeed",
            text: "Speed of Offence",
            sort: true,
            headerStyle: (colum, colIndex) => {
              return { width: '165px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
            },
        },
        {
            dataField: "SpeedLimit",
            text: "Speed Limit",
            hiddenWhenPrint: true,
            headerStyle: (colum, colIndex) => {
              return { width: '110px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
            },
          
        },
        {
            dataField: "ImagePath",
            text: "View",
            csvExport: false,
            id: "DisbalePrint",
            sort: false,
            formatter: (value, row) => (
                // <span>
                //   {value}
                //   {row.SpeedLimit}
                // </span>
                <ViewImageModalComponent ImgPath={value} RecordID={row.RecordID} />
              ),
              headerStyle: (colum, colIndex) => {
                return { width: '60px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              },
        },
        {
         
          dataField: "ImagePath",
          text: "Edit",
          csvExport: false,
          id: "DisbalePrint",
          sort: false,
          formatter: (value, row) => (
              <ViolationsContext.Provider value={Contextvalue}>
              <EditViolationModalComponent ImgPath={value} ViolationData={row}/>
              </ViolationsContext.Provider>
            ),
            headerStyle: (colum, colIndex) => {
              return { width: '60px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
            },
            hidden:!editviolations
      }
    ]

        
              
      const custompagination = paginationFactory({
        page: 1,
        sizePerPage: 10,
        lastPageText: '>>',
        firstPageText: '<<',
        nextPageText: '>',
        prePageText: '<',
        showTotal: true,
        alwaysShowAllBtns: true,
        //all option for pagination
        paginationSize: 3,
        sizePerPageList: [ {
          text: '10', value: 10
        }, 
        {
          text: '50', value: 50
        },
        {
          text: '100', value: 100
        }, {
          text: 'All', value: violations.length
        } ],
        
        onPageChange: function (page, sizePerPage) {
          debugger;
          console.log('page', page);
          console.log('sizePerPage', sizePerPage);
          const startIndex = sizePerPage * page;
          const endIndex = sizePerPage * (page - 1) ;
          handleSliceData(endIndex,startIndex);
          




      
        },
        onSizePerPageChange: function (page, sizePerPage) {
          debugger;
          console.log('Display Data page', page);
          console.log('Display Data sizePerPage', sizePerPage);
          const startIndex = sizePerPage * page;
          const endIndex = (sizePerPage * page) - page ;
          handleSliceData(endIndex,startIndex);
         
        }
      });
      const defaultSorted = [{
        dataField: 'IncidentTime',
        order: 'desc'

      }];


      const handleTableChange = (type,{ sortField, sortOrder }) => {
        debugger;
        // console.log("handleChange->",sortOrder);
        // console.log("handleChange->",sortField);

       custompagination.sizePerPage=10;    
    
      }

      const handleDateTimeChange = e =>
      {
                            debugger;
                            const searchInput = e.target.value.toLowerCase();
                            console.log("searchInput -->", searchInput);
                            const filteredData = data.filter((item) => {     
                                const formattedIncidentTime = item.IncidentTime.replace(' ', 'T').toLowerCase();
                                return formattedIncidentTime.includes(searchInput);
                           });
                      
                            props.searchProps.onChange(e);
      };

      

      // const handleDataChange = (type, {data}) =>{
      //   custompagination.sizePerPage=10;
      //   console.log("handleChange->",data);
      //   debugger;
      //   if (type === 'SearchTable') {
      //     const currentData = componentRef.current.getCurrentData();
      //     console.log(currentData);
      //     // Here, you can access the row data from the 'currentData' array and perform your desired actions.
        
      //   }
      // }
      
      const handleSliceData = (endIndex, startIndex) =>{
        debugger;
      

        var data = violations.map(obj =>{
          var tempData = {};
          const mapping = ['RecordID', 'ImagePath'];
          tempData["RecordID"] = obj.RecordID;
          tempData["ImagePath"] = obj.ImagePath;
          return tempData;
        })
        //data = violations.map(log=> [log.RecordID,log.ImagePath]);
        console.log("sliced Data--->", data);

        setSlicedViolation(data.slice(endIndex,startIndex));
       // const filteredData = data.slice(endIndex, startIndex);
        //console.log("sliced Data----->", filteredData);
      }
    // Note: the empty deps array [] means
    // this useEffect will run once
    // similar to componentDidMount()

const ViolationLogsOnPageLoad = (LocValue) =>{
  setIsLoading(true);

  // UserValidated
  fetch(apiEndpoint+"/GetViolationLogs",
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "intCampusID": selectedCampusVal,// 1,
                "intLocationID": LocValue,//1,
                "intReportType": selectedReportTypeVal,//1,
                "FromDtTm": FromDtTm,
                "ToDtTm": ToDtTm,
                "intSpeedType": selectedSpeedTypeVal,//1,
                "FromSpeed": FromSpeed,
                "ToSpeed": ToSpeed,
                "boolOnlyANPR": BoolANPR,
                "strToken": sessionStorage.getItem("Clear_AuthUser")
            })
        })
        .then(res => res.json())
        .then(
            (result) => {
                if(result!=undefined)
                {
                  debugger;
                  //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                //console.log(result);
                if(JSON.parse(result.Violations).length>0){
                  setViolations(JSON.parse(result.Violations));
                  

                  setSlicedViolation(JSON.parse(result.Violations).slice(0,10));
                  console.log("ViolationOnPageLoad-->", JSON.parse(result.Violations));
                  

                }
                  else
                  setViolations([]);
                }
                setIsLoading(false);
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                //setError(error);
            }
        )


}

    useEffect(() => {

      const decodedToken = jwt.decode(sessionStorage.getItem("Clear_AuthUser"));
      var UserPermissions=JSON.parse(decodedToken.userRolePermissions);
      // var UserPermissions=JSON.parse(sessionStorage.getItem("UserRolePermissions"));
      seteditviolations(UserPermissions.EditViolations)

      // UserValidated
      fetch(apiEndpoint+"/GetLogCampusList",
        {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json',
         },
         body: JSON.stringify({
           "strToken": sessionStorage.getItem("Clear_AuthUser")
           
         })
       })   
      .then(res => res.json())
            .then(
              (result) => {
                if (result != undefined) {
                  //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                  //console.log(result);
                  //console.log(JSON.parse(result.CampusList));
                  if (result.CampusList != undefined) {
                    setCampusItems(JSON.parse(result.CampusList));
                    var campuslst = JSON.parse(result.CampusList);
                    setSelectedCampusItem(campuslst[0]);
                    setCampusSelected(campuslst[0].value);
                    changeCampusSelectHandler(campuslst[0])
                 }
                }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    //console.log(error);
                    // /setError(error);
                }
            )
        
    }, [])
   
    const [Locitems, setLocItems] = useState([]);
    const [SelectedLocitem, setSelectedLocItem] = useState([]);
    const [selectedLocVal, setLocSelected] = useState();


    useEffect(() => {
      debugger;
      // UserValidated
        fetch(apiEndpoint+"/GetLogLocationList",
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              "strToken": sessionStorage.getItem("Clear_AuthUser"),
              "intCampusID": selectedCampusVal
              
            })
          }) 
            .then(res => res.json())
            .then(
                (result) => {
                if (result != undefined) {
                  //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                  if (result.Locations != undefined) {
                    var locArr = JSON.parse(result.Locations);
                    if (Array.isArray(locArr)) {
                      locArr.unshift({ "value": 0, "label": "All" });

                    }
                    if (locArr && locArr.length > 0) {
                      setLocItems(locArr);

                      var loclst =locArr;
                      setSelectedLocItem(loclst[0]);
                      setLocSelected(loclst[0].value);
                      setselectonLoadLocVal(loclst[0].value);
                      ViolationLogsOnPageLoad(loclst[0].value);
                    }
                    // locArr.push({ "value": 0, "label": "All" })
                   
  
                  }
                }
              },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    //console.log(error);
                    // /setError(error);
                }
            )
    }, [selectedCampusVal])

    const changeCampusSelectHandler = (event) => {
        setSelectedCampusItem(event);
        setCampusSelected(event.value);
       
    };

    const changeLocSelectHandler = (event) => {
        setSelectedLocItem(event);
        setLocSelected(event.value);

        
      
    };

    const changeReportTypeHandle = () =>{
      debugger;
     

    }

    const changeFrmSpeedHandler= (value, ctx) => {
        if(value>parseInt(ToSpeed)){
            return "Enter Valid From Speed Value!!";
          }
          return true;
    }

    const changeToSpeedHandler = (value, ctx) => {
        if(value<parseInt(FromSpeed)){
          return "Enter Valid To Speed Value!!";
        }
        return true;
      }
   
      const changeFrmDateHandler= (value, ctx) => {
      //  console.log(value);
        if(value>ToDtTm){
            return "From date cannot be greater than To date!!!";
          }
          return true;
    }

    const changeMonthHandler = (value, ctx) =>{
      debugger;
      let Year = value.split('-');
      if(Year[0] < 2020)
      {
        return "No Data Available";
      }
      console.log(value);
      return true;  

    }

    const changeToDateHandler = (value, ctx) => {
        if(value<FromDtTm){
          return "To date cannot be lesser than From date!!!";
        }
        return true;
      }
   
    
    //SearchViolations();

    // this function will copy to clipboard an entire table,
  // so you can paste it inside an excel or csv file
  const copyToClipboardAsTable = el => {
    var body = document.body,
      range,
      sel;
    if (document.createRange && window.getSelection) {
      range = document.createRange();
      sel = window.getSelection();
      sel.removeAllRanges();
      try {
        range.selectNodeContents(el);
        sel.addRange(range);
      } catch (e) {
        range.selectNode(el);
        sel.addRange(range);
      }
      document.execCommand("copy");
    } else if (body.createTextRange) {
      range = body.createTextRange();
      range.moveToElementText(el);
      range.select();
      range.execCommand("Copy");
    }

    setAlert (
        <ReactBSAlert
          success
        //   style={bsAlertStyle}
        //   title="Good job!"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="info"
        >
          Copied to clipboard!
        </ReactBSAlert>
      )
}
    useEffect(() => {
        props.setBreadcrumbItems('Violation Logs', breadcrumbItems);
      //  SearchViolations();
    })

    
    return (
        <React.Fragment>


            <MetaTags>
                <title>Indus | Violation Logs</title>
            </MetaTags>
            <AvForm className="needs-validation">
            <Row>
                <Col md={2}>
                    <label className="mt-1" > Campus  </label>
                    <Select value={SelectedCampusitem} options={Campusitems} onChange={changeCampusSelectHandler}></Select>
                </Col>
                <Col md={2}>
                    <label className="mt-1" > Location  </label>
                    <Select value={SelectedLocitem} options={Locitems} onChange={changeLocSelectHandler}></Select>
                </Col>
                <Col md={2} >
                    <div
                        className="form-check form-switch form-switch-lg mb-3" style={btnstylesObj}
                    >
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="customSwitchsizelg"
                            defaultChecked
                            onChange={(event) => setANPR(event.target.checked)}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="customSwitchsizelg"
                        >
                            ANPR
                        </label>
                    </div>
                </Col>

            </Row>
            <Row>

                <Col md={2}>

                    <label className="mt-1" > Report Type  </label>
                   
                   <ReportType setReportType={setReportType}
                   onChange ={() => changeReportTypeHandle}
                  
                   ></ReportType>
                </Col>
                <Col sm={2} className="monthlyrt" style={{ display: "none" }}>
                    <label className="form-label mt-1"> Month  </label>
                    <AvField
                    name="monthrt"
                        type="month"
                        validate={{myValidation: changeMonthHandler}}
                        className="form-control"
                        defaultValue={Monthlyrt}
                        id="monthlyrt-input" 
                        onChange={(event) => setMonthlyrt(event.target.value)}

                      />
                  
                </Col>
                <Col sm={2} className="customdttm" style={{ display: "none" }}>
                    <label className="form-label mt-1"> From  </label>
                    <AvField
                    name="frmdttm"
                        type="datetime-local"
                        validate={{myValidation: changeFrmDateHandler}}
                        className="form-control"
                        defaultValue={FromDtTm}
                        id="from-datetime-local-input" 
                        onChange={(event) => setFrmDttm(event.target.value)}
                      />
                    {/* <input className="form-control" type="datetime-local" defaultValue={FromDtTm}
                        id="from-datetime-local-input" 
                        onChange={(event) => setFrmDttm(event.target.value)} /> */}
                </Col>
                <Col sm={2} className="customdttm" style={{ display: "none" }}>

                    <label className="form-label mt-1" > To  </label>
                    <AvField
                    name="todttm"
                        type="datetime-local"
                        validate={{myValidation: changeToDateHandler}}
                        className="form-control"
                        defaultValue={ToDtTm}
                        id="to-datetime-local-input" 
                        onChange={(event) => setToDttm(event.target.value)}
                      />
                    {/* <input className="form-control" type="datetime-local" defaultValue={ToDtTm}
                        id="to-datetime-local-input" onChange={(event) => setToDttm(event.target.value)} /> */}
                </Col>

            </Row>
            <Row>

                <Col md={2}>
                    <label className="mt-1" > Speed Range  </label>
                    <SpeedType setSpeedType={setSpeedType}></SpeedType>
                </Col>
                <Col md={2} className="customspeed" style={{ display: "none" }}>
                    <label className="form-label mt-1"> From  </label>
                    <AvField
                        name="fromspeed"
                        placeholder="From Speed"
                        type="number"
                        errorMessage="Enter From Speed Value"
                        validate={{myValidation: changeFrmSpeedHandler}}
                        className="form-control"
                        defaultValue={FromSpeed}
                        id="from-speed"
                        onChange={(event) => setFrmSpeed(event.target.value)} 
                      />
                </Col>
                <Col md={2} className="customspeed" style={{ display: "none" }}>
                    <label className="form-label mt-1"> To  </label>
                    <AvField
                        name="tospeed"
                        placeholder="To Speed"
                        type="number"
                        errorMessage="Enter To Speed Value"
                        validate={{myValidation: changeToSpeedHandler}}
                        className="form-control"
                        defaultValue={ToSpeed}
                        id="from-speed"
                        onChange={(event) => setToSpeed(event.target.value)}
                        />
                </Col>
                <Col md={2} >

                    <Link className="btn btn-primary waves-effect waves-light" style={btnstylesObj}
                        to="#" role="Button" onClick={SearchViolations} >Search</Link>
                </Col>
            </Row>
            </AvForm>
            <Row className="mt-3">
                <Col>
                    <Card >
                        <CardBody>
                       
                            <div className="table-responsive mt-2">
                             {alertmsg
                             }

                   

                          
                            <ToolkitProvider
                                    keyField="RecordID"
                                    data={violations}
                                    columns={columns}
                                    exportCSV={{
                                      
                                      fileName: datefilename,
                                       // fileName: "ViolationLog.csv",
                                    }}
                                    search={ {
                                      searchFormatted: true
                                    } }
                                >
                               
                                    {
                                        props => (
                                            <div>                          
                <Row>
                  <Col xs={12} sm={4}>
                    <ButtonGroup>
                        <ExportCSV { ...props.csvProps }  />     
                         &nbsp;                   
                        <Button className="buttons-pdf buttons-html5"
                        color="dark"   id="pdf-tooltip"
                        size="sm" onClick={() => exportPDF()}>PDF </Button>    
                       &nbsp;  
                      <Button
                        className="buttons-copy buttons-html5"
                        color="dark"
                        size="sm"
                        id="copy-tooltip"
                        onClick={() =>
                          copyToClipboardAsTable(
                            document.getElementById("react-bs-table")
                          )
                        }
                      >
                        <span>Copy</span>
                      </Button>
                    &nbsp;
                      {/* <ReactToPrint
                        trigger={() => (
                          <Button
                            color="dark"
                            size="sm"
                            className="buttons-copy buttons-html5"
                            id="print-tooltip"
                            
                          >
                           <span>Print</span> 
                          </Button>
                          
                        )}
                        content={() => componentRef.current}
                        documentTitle="ViolationLog"
                      
                      
                      /> */}
                      {/* &nbsp; */}
                      <Button
                        className="buttons-ImageDn buttons-html5"
                        color="dark"
                        size="sm"
                        id="ImageDn-tooltip"
                        onClick={() =>

                          DownloadImage(componentRef)
                        }
                      >
                        <span>Download Images</span>
                      </Button>

                    

                    </ButtonGroup>
                  
                    {/* <UncontrolledTooltip placement="top" target="print-tooltip">
                      This will open a print page with the visible rows of the
                      table.
                    </UncontrolledTooltip> */}
                    <UncontrolledTooltip placement="top" target="copy-tooltip">
                      This will copy to your clipboard the visible rows of the
                      table.
                    </UncontrolledTooltip>
                    <UncontrolledTooltip placement="top" target="csv-tooltip">
                      This will download table data in csv file.
                    </UncontrolledTooltip>
                    <UncontrolledTooltip placement="top" target="pdf-tooltip">
                      This will download table data in pdf file.
                    </UncontrolledTooltip>
                    <UncontrolledTooltip placement="top" target="ImageDn-tooltip">
                      This will download table data Images in zip file.
                      Please download images for maximum 100 records at a time.
                    </UncontrolledTooltip>
                  </Col>
                  <Col xs={12} sm={4}>
                    {isLoading ? (
  <Row>
    <div className="col-sm-1">
    <Spinner /*type="grow" color="primary"*/ style={{ width: '1.75rem', height: '1.75rem' }}>
    </Spinner>
    </div>
    <div className="col-sm-11">
    <h4>Loading Data Please Wait....</h4>

    </div>
    
   
   
     </Row>
  
):(<div>
</div>)}

{isDownloadingImage ? (
  <Row>
    <div className="col-sm-1">
    <Spinner /*type="grow" color="primary"*/ style={{ width: '1.5rem', height: '1.5rem' }}>
    </Spinner>
    </div>
    <div className="col-sm-11">
    <h5>Downloading Images Please Wait....</h5>
   </div>
    
   
   
     </Row>
  
):(<div>
</div>)}
</Col>
                  <Col xs={12} sm={4}>
                    <div
                      id="datatable-basic_filter"
                      className="dataTables_filter px-4 pb-1 float-right"
                    >
                      <label>  
                        <SearchBar
                          className="form-control-sm"
                          placeholder=""
                          {...props.searchProps}
                          // onChange={
                          //   handleDateTimeChange
                          // }
                          
                        />
                      </label>
                    </div>
                  </Col>
                </Row>
            
                
                
               
            <BootstrapTable id="react-bs-table" 
             ref={componentRef}
            { ...props.baseProps }  
            onTableChange={handleTableChange}
            onSort={ handleTableChange}
           
            pagination={custompagination}
            
           /> 
           
                                                
            </div>

                                        )
                                    }
                                </ToolkitProvider>
                              
                            </div>

                          
                            
                        </CardBody>
                      
                    </Card>
                </Col>
            </Row>
<Row>
</Row>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(ViolationTables);
